import { ReturnStatusZod } from "@redotech/redo-model/return-status";
import * as z from "zod";

const URL_LIKE_PATTERN = /[:/.]/;

const companyIdSchema = z
  .string()
  .min(1, "Company ID is required")
  .refine((val) => !URL_LIKE_PATTERN.test(val), {
    message:
      "Company ID should be just the subdomain, not a full URL. For example, enter 'yourstore' instead of 'yourstore.app.apparelmagic.com'.",
  });

const creditMemoSchema_ = z.object({
  enabled: z.boolean(),
  restock: z.boolean(),
  triggerStatus: ReturnStatusZod,
});
export const creditMemoSchema: z.ZodType<CreditMemoSchema> = creditMemoSchema_;
export interface CreditMemoSchema extends z.infer<typeof creditMemoSchema_> {}

const raMiscChargesSchema_ = z.object({
  enabled: z.boolean(),
  glAcct: z.string().min(1, "GL account is required"),
});

const returnAuthorizationSchema_ = z.object({
  miscCharges: raMiscChargesSchema_,
});

export const setApparelMagicIntegration = {
  name: "setApparelMagicIntegration" as const,
  input: z.object({
    apiKey: z.string().min(1, "API key is required"),
    companyId: companyIdSchema,
    creditMemo: creditMemoSchema_,
    returnAuthorization: returnAuthorizationSchema_.optional(),
  }),
  output: z.object({}),
};

export type SetApparelMagicIntegrationInput = z.infer<
  typeof setApparelMagicIntegration.input
>;

export const updateApparelMagicIntegration = {
  name: "updateApparelMagicIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    companyId: companyIdSchema.optional(),
    creditMemo: creditMemoSchema_.optional(),
    returnAuthorization: returnAuthorizationSchema_.optional(),
  }),
  output: z.object({}),
};

export type UpdateApparelMagicIntegrationInput = z.infer<
  typeof updateApparelMagicIntegration.input
>;

export const getApparelMagicIntegration = {
  name: "getApparelMagicIntegration" as const,
  input: z.object({}),
  output: z.object({
    apparelMagicIntegration: z.optional(
      z.object({
        companyId: z.string(),
        creditMemo: creditMemoSchema_,
        returnAuthorization: returnAuthorizationSchema_,
        // API key is intentionally omitted from the output for security
      }),
    ),
  }),
};

export type GetApparelMagicIntegrationOutput = z.infer<
  typeof getApparelMagicIntegration.output
>;

export const disconnectApparelMagicIntegration = {
  name: "disconnectApparelMagicIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
